import { render, staticRenderFns } from "./ChatToolBar.vue?vue&type=template&id=9ffb2c1e&scoped=true"
import script from "./ChatToolBar.vue?vue&type=script&lang=js"
export * from "./ChatToolBar.vue?vue&type=script&lang=js"
import style0 from "./ChatToolBar.vue?vue&type=style&index=0&id=9ffb2c1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffb2c1e",
  null
  
)

export default component.exports